import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SiteForm } from './create-order-site.interface';
import { BaseService } from '../../../../../services/base.service';
import { Subject } from 'rxjs';
import { NotificationService } from '../../../../../services/notifications.service';
import { IError } from '../../../../../interfaces';
import { activeTranslations } from '../../../../../enum/constants';
import { PropsService } from '../../../../../services/props.service';

@Component({
  selector: 'app-create-order-site',
  templateUrl: './create-order-site.component.html',
  styleUrls: ['./create-order-site.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateOrderSiteComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();
  public siteForm!: FormGroup<SiteForm>;

  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  constructor(
    public readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
    private propsService: PropsService,
  ) {}

  public ngOnInit() {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private initForm() {
    this.siteForm = new FormGroup<SiteForm>({
      name: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
    });
  }

  public onSubmit(): void {
    this.siteForm.markAllAsTouched();
    if (this.siteForm.valid) {
      const payload: SiteForm = this.siteForm.getRawValue();

      this.propsService.notifyOrderSite(payload).subscribe(
        () => {
          this.notificationService.showInfo(
            activeTranslations.notifications_texts.info.thanks_for_order,
            '',
          );
          this.close.emit('close');
        },
        (error) => {
          console.error('Ошибка при отправке запроса:', error);
        },
      );
    }
  }

  public onNoClick(): void {
    this.close.emit('close');
  }
}
